module.exports = __webpack_public_path__ + "img/Spain.bdb3ef28.png";